// @ts-nocheck
import t from './editItem.types';

const initialState = {
  activeView: 0,
  stages: [],
  formData: {},
  stageFormData: {},
  hasVariants: true,
  variants: [],
  variantSchema: [],
  images: { 0: [] },
  subtotals: { 0: 0 },
  variantsTotals: { 0: 0 },
  chargesTotals: { 0: 0 },
  decorationsTotals: { 0: 0 },
  charges: { 0: [] },
  decorations: { 0: [] },
};

export default function editItemReducer(state = initialState, action) {
  switch (action.type) {
    case t.EDIT_ITEM_SET_ACTIVE_VIEW:
      return {
        ...state,
        activeView: action.payload,
      };

    case t.EDIT_ITEM_SET_STAGES:
      return {
        ...state,
        stages: action.payload,
      };

    case t.EDIT_ITEM_ADD_STAGE:
      return {
        ...state,
        stages: [...state.stages, action.payload],
        subtotals: { ...state.subtotals, [action.payload.id]: 0 },
        variantsTotals: { ...state.variantsTotals, [action.payload.id]: 0 },
        chargesTotals: { ...state.chargesTotals, [action.payload.id]: 0 },
        decorationsTotals: { ...state.decorationsTotals, [action.payload.id]: 0 },
        charges: { ...state.charges, [action.payload.id]: [] },
        decorations: { ...state.decorations, [action.payload.id]: [] },
      };

    case t.EDIT_ITEM_DELETE_STAGE:
      const { [action.payload]: removedSubtotal, ...restSubtotals } = state.subtotals;
      const { [action.payload]: removedCharges, ...restCharges } = state.charges;
      const { [action.payload]: removedDecorations, ...restDecorations } = state.decorations;
      const { [action.payload]: removedStageFormData, ...restStageFormData } = state.stageFormData;
      return {
        ...state,
        stages: state.stages.filter(stage => stage.id !== action.payload),
        activeView: state.activeView === action.payload ? 0 : state.activeView,
        subtotals: restSubtotals,
        charges: restCharges,
        decorations: restDecorations,
        stageFormData: restStageFormData,
      };

    case t.EDIT_ITEM_SET_STAGE_FORM_DATA:
      return {
        ...state,
        stageFormData: {
          ...state.stageFormData,
          [action.payload.stageId]: {
            ...(state.stageFormData[action.payload.stageId] || {}),
            ...action.payload.data,
          },
        },
      };

    case t.EDIT_ITEM_SET_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          ...action.payload,
        },
      };

    case t.EDIT_ITEM_SET_HAS_VARIANTS:
      return {
        ...state,
        hasVariants: action.payload,
      };

    case t.EDIT_ITEM_SET_SUBTOTAL:
      return {
        ...state,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]: action.payload.subtotal,
        },
      };

    case t.EDIT_ITEM_SET_VARIANTS_TOTAL:
      const newVariantsTotal = {
        ...state.variantsTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        variantsTotals: newVariantsTotal,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]: Number(newVariantsTotal[action.payload.view]) + Number(state.chargesTotals[action.payload.view]) + Number(state.decorationsTotals[action.payload.view]),
        },
      };

    case t.EDIT_ITEM_SET_CHARGES_TOTAL:
      const newChargesTotals = {
        ...state.chargesTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        chargesTotals: newChargesTotals,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]: Number(state.variantsTotals[action.payload.view]) + Number(newChargesTotals[action.payload.view]) + Number(state.decorationsTotals[action.payload.view]),
        },
      };

    case t.EDIT_ITEM_SET_DECORATIONS_TOTAL:
      const newDecorationsTotals = {
        ...state.decorationsTotals,
        [action.payload.view]: action.payload.total,
      };
      return {
        ...state,
        decorationsTotals: newDecorationsTotals,
        subtotals: {
          ...state.subtotals,
          [action.payload.view]: Number(state.variantsTotals[action.payload.view]) + Number(state.chargesTotals[action.payload.view]) + Number(newDecorationsTotals[action.payload.view]),
        },
      };

    case t.EDIT_ITEM_SET_CHARGES:
      return {
        ...state,
        charges: {
          ...state.charges,
          [action.payload.view]: action.payload.charges,
        },
      };

    case t.EDIT_ITEM_SET_DECORATION:
      return {
        ...state,
        decorations: {
          ...state.decorations,
          [action.payload.view]: action.payload.decoration,
        },
      };

    case t.EDIT_ITEM_SET_VARIANTS:
      return {
        ...state,
        variants: action.payload,
      };

    case t.EDIT_ITEM_SET_IMAGES:
      return {
        ...state,
        images: action.payload,
      };

    case t.EDIT_ITEM_SET_VARIANT_SCHEMA:
      return {
        ...state,
        variantSchema: action.payload,
      };

    case t.EDIT_ITEM_RESET:
      return initialState;

    default:
      return state;
  }
}
